import { ReactNode } from 'react';

import { cn } from '../../../libs/utils';

export interface AdditionalInfoProps {
  divider?: boolean;
  boxButton?: ReactNode;
  info: ReactNode;
  className?: string;
}

export const AdditionalInfo = ({ divider = true, boxButton, info, className, ...props }: AdditionalInfoProps) => {
  return (
    <div
      className={cn(
        'inline-flex items-center justify-center gap-tiny-large text-neutral-foreground-low',
        {
          'border-t border-solid border-t-neutral-border-main px-normal-medium py-normal-large': divider
        },
        className
      )}
      {...props}
    >
      {info}
      {boxButton}
    </div>
  );
};
